var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_222315)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_222315",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_222315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9237 14.3995L11.7016 9L14.9237 3.60056L16.5004 9L14.9237 14.3995ZM7.7985 13.8751L3.75019 9.89947H10.2015L13.4235 15.2989L7.7985 13.8751ZM7.7985 4.04831L13.4235 2.62462L10.2015 8.0241H3.67369C3.67369 8.1006 7.7985 4.04831 7.7985 4.04831ZM16.0487 0L8.70187 1.87481L7.57687 3.74962H5.39944L0 8.9994L5.39944 14.2492H7.57687L8.62537 16.1241L15.9761 17.9989L17.924 10.8736L16.8755 8.99887L18.0005 7.12406L16.0487 0Z",
    fill: "#667085"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_222315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitSetting);
export default __webpack_public_path__ + "static/media/Unit_Setting.2c6284f7485939fc3a2f4f3593c5883c.svg";
export { ForwardRef as ReactComponent };